module.exports = __webpack_public_path__ + "media/images/responsive/icon/icon_arrow_white-f6ed8d3ef19f46b4049104207283cc4f.svg";